module.exports = __webpack_public_path__ + "static/media/andy.96451585.jpg";